import { Seguradoras } from "#/enums";
import { ALIRO_LOGO, YELUM_LOGO } from "#/images";

export const logoSeguradoras: { [key in Seguradoras]: string } = {
  [Seguradoras.ALIRO]: ALIRO_LOGO,
  [Seguradoras.YELUM]: YELUM_LOGO,
};

export const planosValidos = ["basico", "intermediario", "avancado"];
